const config = {
  // // Localhost
  // API_BASE_URL: "http://localhost:3001/",
  // IMAGE_URL: "http://localhost:3001/",
  // APP_URL: "http://localhost:3000/",  
  // JAVA_API_BASE_URL: "http://localhost:8080/",
  // AWS_PUBLIC_BUCKET_URL: "https://hrms-hg-assets.s3.us-east-2.amazonaws.com/",

  // IMAGE_URL: "http://localhost:3001/uploads/",
  Captcha_SiteKey: "6LetgBkrAAAAABFE9c665MpB2IOnDYh0lRXWt3Zg",

  // production
  API_BASE_URL: "https://bk.annapurameal.com:3445/",
  IMAGE_URL: "https://bk.annapurameal.com:4443/",
  APP_URL: "https://application.hrglobes.com/",
  JAVA_API_BASE_URL: "https://api.hrglobes.com/",
  AWS_PUBLIC_BUCKET_URL: "https://hrms-hg-assets.s3.us-east-2.amazonaws.com/",
};

export default config;
